// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.edm-suncorp-wrapper {
  height: 100vh;
  margin: 0;
  padding: 0;
  -webkit-text-size-adjust: 100%;
  -ms-text-size-adjust: 100%;
  -webkit-font-smoothing: antialiased;
  background-color: #e9e9e9; }
  .edm-suncorp-wrapper table {
    background: none; }
  .edm-suncorp-wrapper .em_main_table {
    width: 700px;
    table-layout: fixed; }
  .edm-suncorp-wrapper .em_font1111 {
    font-size: 15px;
    line-height: 19px;
    font-weight: normal;
    font-style: normal;
    color: #eb5d54;
    padding: 8px 0 8px 0; }
  .edm-suncorp-wrapper .logo1 {
    display: block;
    width: 148px;
    height: 44px; }
  .edm-suncorp-wrapper .em_img {
    display: block;
    width: 700px;
    height: 230px; }
  .edm-suncorp-wrapper .em_padding15 {
    padding: 0 15px 0 15px; }
  .edm-suncorp-wrapper .em_font17 {
    font-size: 19px;
    line-height: 23px;
    font-weight: bold;
    font-style: normal;
    color: #004346;
    padding: 34px 0 0 0; }
  .edm-suncorp-wrapper .em_font15 {
    font-size: 15px;
    line-height: 19px;
    font-weight: normal;
    font-style: normal;
    color: #000000;
    padding: 14px 0 35px 0; }
  .edm-suncorp-wrapper .em_font20 {
    font-size: 25px;
    line-height: 30px;
    font-weight: bold;
    font-style: normal;
    color: #ffffff;
    padding: 36px 0 9px 0; }
  .edm-suncorp-wrapper .em_font12 {
    font-size: 12px;
    line-height: 16px;
    font-weight: normal;
    font-style: normal;
    color: #ffffff;
    padding: 11px 0 0 0; }
  .edm-suncorp-wrapper .em_font1 {
    font-size: 15px;
    line-height: 22px;
    font-weight: normal;
    font-style: normal;
    color: #ffffff;
    padding: 28px 0 0 0; }
  .edm-suncorp-wrapper .em_font2 {
    font-family: Arial, sans-serif;
    font-size: 14px;
    line-height: 20px;
    font-weight: bold;
    font-style: normal;
    color: #004346;
    padding: 13px 0 12px 0; }
  .edm-suncorp-wrapper .em_font3 {
    font-size: 15px;
    line-height: 19px;
    font-weight: normal;
    font-style: normal;
    color: #000000;
    padding: 38px 10px 38px 0; }
  .edm-suncorp-wrapper .em_font16 {
    font-size: 18px;
    line-height: 22px;
    font-weight: bold;
    font-style: normal;
    color: #ffffff;
    padding: 34px 0 34px 0; }
  .edm-suncorp-wrapper .em_font4 {
    font-size: 11px;
    line-height: 15px;
    font-weight: normal;
    font-style: normal;
    color: #737373;
    padding: 34px 0 34px 0; }
  .edm-suncorp-wrapper .em_full_wrap {
    background-color: #e9e9e9; }

@media only screen and (max-width: 630px) {
  .edm-suncorp-wrapper .em_img {
    width: 100% !important;
    height: auto !important; }
  .edm-suncorp-wrapper .em_main_table {
    width: 100% !important; }
  .edm-suncorp-wrapper .em_wrapper {
    width: 100% !important; }
  .edm-suncorp-wrapper .em_height {
    height: auto !important; }
  .edm-suncorp-wrapper .em_hide {
    display: none !important; }
  .edm-suncorp-wrapper .em_padding {
    padding-left: 10px !important;
    padding-right: 10px !important; }
  .edm-suncorp-wrapper .em_font17 {
    font-size: 17px !important;
    line-height: 21px !important; }
  .edm-suncorp-wrapper .em_font20 {
    font-size: 20px !important;
    line-height: 24px !important; }
  .edm-suncorp-wrapper .em_font16 {
    font-size: 16px !important;
    line-height: 20px !important; }
  .edm-suncorp-wrapper .em_font {
    font-size: 10px !important;
    line-height: 14px !important; }
  .edm-suncorp-wrapper u + .em_body .em_full_wrap {
    width: 100% !important;
    width: 100vw !important; } }
`, "",{"version":3,"sources":["webpack://./src/pages/custom-redeem/edm/suncorp-banking/EdmSuncorpBanking.scss"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,SAAS;EACT,UAAU;EACV,8BAA8B;EAC9B,0BAA0B;EAC1B,mCAAmC;EACnC,yBAAyB,EAAA;EAP3B;IAUI,gBAAgB,EAAA;EAVpB;IAaI,YAAY;IACZ,mBAAmB,EAAA;EAdvB;IAiBI,eAAe;IACf,iBAAiB;IACjB,mBAAmB;IACnB,kBAAkB;IAClB,cAAc;IACd,oBAAoB,EAAA;EAtBxB;IAyBI,cAAc;IACd,YAAY;IACZ,YAAY,EAAA;EA3BhB;IA8BI,cAAc;IACd,YAAY;IACZ,aAAa,EAAA;EAhCjB;IAmCI,sBAAsB,EAAA;EAnC1B;IAsCI,eAAe;IACf,iBAAiB;IACjB,iBAAiB;IACjB,kBAAkB;IAClB,cAAc;IACd,mBAAmB,EAAA;EA3CvB;IA8CI,eAAe;IACf,iBAAiB;IACjB,mBAAmB;IACnB,kBAAkB;IAClB,cAAc;IACd,sBAAsB,EAAA;EAnD1B;IAsDI,eAAe;IACf,iBAAiB;IACjB,iBAAiB;IACjB,kBAAkB;IAClB,cAAc;IACd,qBAAqB,EAAA;EA3DzB;IA8DI,eAAe;IACf,iBAAiB;IACjB,mBAAmB;IACnB,kBAAkB;IAClB,cAAc;IACd,mBAAmB,EAAA;EAnEvB;IAsEI,eAAe;IACf,iBAAiB;IACjB,mBAAmB;IACnB,kBAAkB;IAClB,cAAc;IACd,mBAAmB,EAAA;EA3EvB;IA8EI,8BAA8B;IAC9B,eAAe;IACf,iBAAiB;IACjB,iBAAiB;IACjB,kBAAkB;IAClB,cAAc;IACd,sBAAsB,EAAA;EApF1B;IAuFI,eAAe;IACf,iBAAiB;IACjB,mBAAmB;IACnB,kBAAkB;IAClB,cAAc;IACd,yBAAyB,EAAA;EA5F7B;IA+FI,eAAe;IACf,iBAAiB;IACjB,iBAAiB;IACjB,kBAAkB;IAClB,cAAc;IACd,sBAAsB,EAAA;EApG1B;IAuGI,eAAe;IACf,iBAAiB;IACjB,mBAAmB;IACnB,kBAAkB;IAClB,cAAc;IACd,sBAAsB,EAAA;EA5G1B;IAgHI,yBAAyB,EAAA;;AAI7B;EACE;IACY,sBAAsB;IAAE,uBAAuB,EAAA;EAD3D;IAEkB,sBAAsB,EAAA;EAFxC;IAGe,sBAAsB,EAAA;EAHrC;IAIc,uBAAsB,EAAA;EAJpC;IAKY,wBAAwB,EAAA;EALpC;IAMe,6BAA6B;IAAE,8BAA8B,EAAA;EAN5E;IAOc,0BAA0B;IAAE,4BAA4B,EAAA;EAPtE;IAQc,0BAA0B;IAAE,4BAA4B,EAAA;EARtE;IASc,0BAA0B;IAAE,4BAA4B,EAAA;EATtE;IAUY,0BAA0B;IAAE,4BAA4B,EAAA;EAVpE;IAW+B,sBAAsB;IAAE,uBAAuB,EAAA,EAAG","sourcesContent":[".edm-suncorp-wrapper {\n  height: 100vh;\n  margin: 0;\n  padding: 0;\n  -webkit-text-size-adjust: 100%;\n  -ms-text-size-adjust: 100%;\n  -webkit-font-smoothing: antialiased;\n  background-color: #e9e9e9;\n\n  table {\n    background: none;\n  }\n  .em_main_table {\n    width: 700px;\n    table-layout: fixed;\n  }\n  .em_font1111 {\n    font-size: 15px;\n    line-height: 19px;\n    font-weight: normal;\n    font-style: normal;\n    color: #eb5d54;\n    padding: 8px 0 8px 0;\n  }\n  .logo1 {\n    display: block;\n    width: 148px;\n    height: 44px;\n  }\n  .em_img {\n    display: block;\n    width: 700px;\n    height: 230px;\n  }\n  .em_padding15 {\n    padding: 0 15px 0 15px;\n  }\n  .em_font17 {\n    font-size: 19px;\n    line-height: 23px;\n    font-weight: bold;\n    font-style: normal;\n    color: #004346;\n    padding: 34px 0 0 0;\n  }\n  .em_font15 {\n    font-size: 15px;\n    line-height: 19px;\n    font-weight: normal;\n    font-style: normal;\n    color: #000000;\n    padding: 14px 0 35px 0;\n  }\n  .em_font20 {\n    font-size: 25px;\n    line-height: 30px;\n    font-weight: bold;\n    font-style: normal;\n    color: #ffffff;\n    padding: 36px 0 9px 0;\n  }\n  .em_font12 {\n    font-size: 12px;\n    line-height: 16px;\n    font-weight: normal;\n    font-style: normal;\n    color: #ffffff;\n    padding: 11px 0 0 0;\n  }\n  .em_font1 {\n    font-size: 15px;\n    line-height: 22px;\n    font-weight: normal;\n    font-style: normal;\n    color: #ffffff;\n    padding: 28px 0 0 0;\n  }\n  .em_font2 {\n    font-family: Arial, sans-serif;\n    font-size: 14px;\n    line-height: 20px;\n    font-weight: bold;\n    font-style: normal;\n    color: #004346;\n    padding: 13px 0 12px 0;\n  }\n  .em_font3 {\n    font-size: 15px;\n    line-height: 19px;\n    font-weight: normal;\n    font-style: normal;\n    color: #000000;\n    padding: 38px 10px 38px 0;\n  }\n  .em_font16 {\n    font-size: 18px;\n    line-height: 22px;\n    font-weight: bold;\n    font-style: normal;\n    color: #ffffff;\n    padding: 34px 0 34px 0;\n  }\n  .em_font4 {\n    font-size: 11px;\n    line-height: 15px;\n    font-weight: normal;\n    font-style: normal;\n    color: #737373;\n    padding: 34px 0 34px 0;\n  }\n\n  .em_full_wrap {\n    background-color: #e9e9e9;\n  }\n}\n\n@media only screen and (max-width: 630px){\n  .edm-suncorp-wrapper {\n    .em_img { width: 100% !important; height: auto !important; }\n    .em_main_table {width: 100% !important;}\n    .em_wrapper {width: 100% !important;}\n    .em_height {height:auto !important;}\n    .em_hide {display: none !important;\t}\n    .em_padding {padding-left: 10px !important; padding-right: 10px !important;\t}\n    .em_font17 {font-size: 17px !important; line-height: 21px !important;\t}\n    .em_font20 {font-size: 20px !important; line-height: 24px !important;\t}\n    .em_font16 {font-size: 16px !important; line-height: 20px !important;\t}\n    .em_font {font-size: 10px !important; line-height: 14px !important;\t}\n    u + .em_body .em_full_wrap { width: 100% !important; width: 100vw !important;}\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
